import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 7.58a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 8 7.58Zm-.233-3.22a1.002 1.002 0 0 1 1.005 1.6 1.001 1.001 0 1 1-1.005-1.6Z M6.67 1.38A6.75 6.75 0 0 1 14.74 8 6.76 6.76 0 0 1 8 14.75a6.752 6.752 0 0 1-6.631-8.06 6.75 6.75 0 0 1 5.3-5.31ZM8 2.75A5.25 5.25 0 1 0 13.24 8a5.25 5.25 0 0 0-1.538-3.702A5.26 5.26 0 0 0 8 2.75Z';
const draw24px =
  'M12,21.75A9.75,9.75,0,1,1,21.75,12,9.76,9.76,0,0,1,12,21.75Zm0-18A8.25,8.25,0,1,0,20.25,12,8.26,8.26,0,0,0,12,3.75ZM12.75,17V12a.75.75,0,0,0-1.5,0v5a.75.75,0,0,0,1.5,0ZM12,6.75A1.25,1.25,0,1,0,13.25,8,1.25,1.25,0,0,0,12,6.75Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ICircleIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'iCircle'),
) as IconWithRender;

ICircleIcon.displayName = 'ICircleIcon';
ICircleIcon.propTypes = Icon.propTypes;
ICircleIcon.renderIcon = (props) => <ICircleIcon {...props} />;
export default ICircleIcon;
